import {
	NOTIFICATION_CENTER_TABS,
	type NotificationCenterTab,
} from "web_myplann/NotificationCenter/Constants/notificationCenterTabs";
import { useRecentTimelineGroups } from "web_myplann/NotificationCenter/Hooks/useRecentTimelineGroups";
import { useUpcomingTimelineGroups } from "web_myplann/NotificationCenter/Hooks/useUpcomingTimelineGroups";
import { sumGroupItems } from "web_myplann/Shared/Utils/sumGroupItems";

export const useNotificationCenterCounts = (
	activeTab: NotificationCenterTab,
): { shown: number | undefined } => {
	const isUpcoming = activeTab === NOTIFICATION_CENTER_TABS.Upcoming;
	const { upcomingQuery, resolvingNowQuery, resolvingNow, timeGroups } =
		useUpcomingTimelineGroups({ enabled: isUpcoming });
	const { query: recentQuery, groups: recentGroups } = useRecentTimelineGroups({
		enabled: !isUpcoming,
	});

	const upcomingShown =
		upcomingQuery.data && resolvingNowQuery.data
			? resolvingNow.length + sumGroupItems(timeGroups)
			: undefined;
	// TODO(DEV-5435 BE): show the count from meta.total once the BE returns it
	const recentShown =
		recentQuery.data && !recentQuery.hasNextPage
			? sumGroupItems(recentGroups)
			: undefined;

	return { shown: isUpcoming ? upcomingShown : recentShown };
};
